<template>
  <div>
    <div v-for="item in imageMarkerList" :key="'imageMarker'+item.mainId">
      <image-marker :imageMarkerInfo="item" @clickImageMarker="clickImageMarker"></image-marker>
    </div>
  </div>
</template>

<script>
import ImageMarker from "@/views/globe/globe_marker/ImageMarker";
export default {
  name: "ImageMarkerEntry",
  props:['imageMarkerList'],
  components: {ImageMarker},
  methods:{
    clickImageMarker(markerInfo){
      this.$emit("clickImageMarker",markerInfo)
    }
  }
}
</script>

<style scoped>

</style>